declare global {
  interface Window {
    AndroidBridge?: {
      saveBase64File(base64Data: string, filename: string, mimeType: string): void;
    };
  }
}

function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result as string;
      // reader.result is a data: URL ("data:audio/mpeg;base64,AAAA..."); the
      // bridge only wants the payload after the comma.
      resolve(result.slice(result.indexOf(",") + 1));
    };
    reader.onerror = () => reject(reader.error ?? new Error("Failed to read blob"));
    reader.readAsDataURL(blob);
  });
}

/**
 * Saves a blob through the Android WebView wrapper's native bridge when
 * present (a plain WebView doesn't reliably handle `<a download>` on blob:
 * URLs the way a real browser does). Returns false when there's no bridge,
 * so the caller can fall back to the normal browser download.
 */
export async function saveBlobViaNativeBridge(blob: Blob, filename: string, mimeType: string): Promise<boolean> {
  const bridge = window.AndroidBridge;
  if (!bridge) return false;
  const base64 = await blobToBase64(blob);
  bridge.saveBase64File(base64, filename, mimeType);
  return true;
}
